import React, { Fragment, Component } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { Redirect, Route, Switch, Router } from 'react-router-dom';
// import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withLocalize } from 'react-localize-redux';
import Loadable from 'react-loadable';
import { get, has } from 'lodash';
import { compose } from 'recompose';

// import Login from './components/login';
// import Signup from './components/signup';
import AccountLoginView from './components/login/accountLogin';
import AccountSignupView from './components/signup/accountSignup';
import ProfileSignupView from './components/signup/profileSignup';
import ResetPasswordV2 from './components/login/resetPasswordV2';
import history from './hhHistory';
import { PrivateRoute } from './components/common/components';
import Loader from './components/common/loader';
import { receiveMessage, joinRoom, emailVerificationEmail } from './components/notifications/socket';
import { receiveNewNotification } from './components/actions/notification';
import { emailVerficationSuccess } from './components/actions';
import Footer from './components/common/footer';
import HelmetMetaData from './components/common/helmet';
import EventList from './components/events/list';

import Policy from './components/common/policy';

// Languages
import translation from './i18n/translations';

// Google Analytics
import GoogleAnalytics from './components/common/ga';

const UserTickets = Loadable({
  loader: () => import('./components/tickets/userTickets'),
  loading: Loader
});

const ProfileDashboard = Loadable({
  loader: () => import('./components/profile'),
  loading: Loader
});

const UserProfile = Loadable({
  loader: () => import('./components/profile/user'),
  loading: Loader
});
const VerifyEmail = Loadable({
  loader: () => import('./components/profile/verifyEmail'),
  loading: Loader
});
const RequestResetPassword = Loadable({
  loader: () => import('./components/login/requestResetPassword'),
  loading: Loader
});
const ResetPassword = Loadable({
  loader: () => import('./components/login/resetPassword'),
  loading: Loader
});
const linkedinLogin = Loadable({
  loader: () => import('./components/login/linkedinLogin'),
  loading: Loader
});
const githubLogin = Loadable({
  loader: () => import('./components/login/githubLogin'),
  loading: Loader
});
const InstagramLogin = Loadable({
  loader: () => import('./components/login/instagramLogin'),
  loading: Loader
});
const SignupPolicy = Loadable({
  loader: () => import('./components/agreementsAndPolicies/signupPolicy'),
  loading: Loader
});
const SignupPolicyCN = Loadable({
  loader: () => import('./components/agreementsAndPolicies/signupPolicyCN'),
  loading: Loader
});
const EventDashboard = Loadable({
  loader: () => import('./components/events'),
  loading: Loader
});
const EventInviteToken = Loadable({
  loader: () => import('./components/events/inviteToken'),
  loading: Loader
});
const EventDetail = Loadable({
  loader: () => import('./components/events/detail'),
  loading: Loader
});
const Homepage = Loadable({
  loader: () => import('./components/events/homepage'),
  loading: Loader
});
const NotFound = Loadable({
  loader: () => import('./components/common/notFound'),
  loading: Loader
});
const HHCompleteProfileDialog = Loadable({
  loader: () => import('./components/dialogs/completeProfile'),
  loading: Loader
});

const AdminEvent = Loadable({
  loader: () => import('./components/cms/eventDetail'),
  loading: Loader
});
const AdminCreateEvent = Loadable({
  loader: () => import('./components/cms/createEvent'),
  loading: Loader
});

const AdminDashboard = Loadable({
  loader: () => import('./components/cms'),
  loading: Loader
});

const NotificationPage = Loadable({
  loader: () => import('./components/notifications'),
  loading: Loader
});

const Xinshi = Loadable({
  loader: () => import('./components/xinshi'),
  loading: Loader
});

const Zoomus = Loadable({
  loader: () => import('./components/events/components/zoomus'),
  loading: Loader
});

class HHRouter extends Component {
  constructor(props) {
    super(props);

    const domain = window.location.href;
    let isCNDomain = false;
    if (domain.includes('event.hackhub.cn')) {
      isCNDomain = true;
    }

    this.props.initialize({
      languages: [
        { name: 'English', code: 'en' },
        { name: 'Chinese (Simplified)', code: 'zh-Hans' }
      ],
      translation,
      options: {
        renderToStaticMarkup,
        renderInnerHtml: true,
        defaultLanguage: localStorage.getItem('language') || (isCNDomain ? 'zh-Hans' : 'en')
      },
      isCNDomain
    });

    this.state = { isCNDomain };
  }

  componentDidMount() {
    const { user } = this.props;

    if (has(user, 'profile.basicInfo.id')) {
      joinRoom(`U${user.profile.basicInfo.id}`, new Date());
    }

    receiveMessage(data => {
      this.props.receiveNewNotification(data);
    });

    if (has(user, 'profile.basicInfo.id') && !get(user, 'profile.basicInfo.isEmailVerified')) {
      emailVerificationEmail(data => {
        this.props.emailVerficationSuccess(data);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { user } = nextProps;
    if (has(user, 'profile.basicInfo.id')) {
      joinRoom(`U${user.profile.basicInfo.id}`, new Date());
    }

    if (has(user, 'profile.basicInfo.id') && !get(user, 'profile.basicInfo.isEmailVerified')) {
      emailVerificationEmail(data => {
        this.props.emailVerficationSuccess(data);
      });
    }
  }

  render() {
    const { isCNDomain } = this.state;

    return (
      <Router history={history}>
        <Fragment>
          <HelmetMetaData isCNDomain={isCNDomain} />
          {GoogleAnalytics.init() && <GoogleAnalytics.RouteTracker />}
          <Switch>
            <Route exact path='/' component={EventDashboard} />
            <Route path='/lists' render={(props) => <EventList {...props} />} />
            <Route exact path='/qr' component={() => <Redirect to='/login/qr' />} />
            {/* <Route path='/login' component={Login} /> */}
            <Route path='/login' component={AccountLoginView} />
            <Route path='/reset_password_v2' component={ResetPasswordV2} />
            <Route path='/reset_password' component={RequestResetPassword} />
            <Route path='/new_password/:resetToken' component={ResetPassword} />
            <Route path='/oauth/linkedin' exact component={linkedinLogin} />
            <Route path='/oauth/github' exact component={githubLogin} />
            <Route path='/oauth/instagram' exact component={InstagramLogin} />
            {/* <Route path='/signup' component={Signup} /> */}
            <Route exact path='/signup' component={AccountSignupView} />
            <Route exact path='/signup/profile' component={ProfileSignupView} />
            <Route path='/signup_policy' component={isCNDomain ? SignupPolicyCN : SignupPolicy} />
            <PrivateRoute
              path='/admin/event/:eventSlug'
              component={AdminEvent}
            />
            <PrivateRoute exact path='/admin' component={AdminDashboard} />
            <PrivateRoute
              exact
              path='/admin/create-event'
              component={AdminCreateEvent}
            />
            <PrivateRoute
              exact
              path='/profile'
              component={ProfileDashboard}
            />
            <PrivateRoute
              exact
              path='/user/tickets'
              component={UserTickets}
            />
            <Route
              exact
              path='/complete-profile'
              component={HHCompleteProfileDialog}
            />
            <Route exact path='/u/:userName' component={UserProfile} />
            <Route exact path='/events' component={EventDashboard} />
            <PrivateRoute exact path='/notifications' component={NotificationPage} />
            <Route exact path='/event/:eventSlug/home/:pageName' component={Homepage} />
            <Route exact path='/event/:eventSlug/live-streaming/zoomus' component={Zoomus} />
            <Route path='/event/:eventSlug' component={EventDetail} />
            <PrivateRoute
              exact
              path='/e/:eventSlug/:inviteToken'
              component={EventInviteToken}
            />
            <Route
              exact
              path='/email_confirm/:confirmToken'
              component={VerifyEmail}
            />
            <Route
              path='/xingshi'
              component={Xinshi}
            />
            <Route component={NotFound} />
          </Switch>
          {/* <Alert stack={{ limit: 3 }} /> */}
          <ToastContainer hideProgressBar newestOnTop />
          <Footer />
          <Policy />
        </Fragment>
      </Router>
    );
  }
}

export default compose(
  withLocalize,
  connect(
    ({ user, loader }) => ({ user, loader }),
    { receiveNewNotification, emailVerficationSuccess }
  ),
)(HHRouter);



// WEBPACK FOOTER //
// ./src/hhRouter.js